import React from 'react';
import { motion, useScroll } from "motion/react"
import '../style/main.css';
import '../style/Layout.css';

import Intro from '../component/Intro';
import Profile from '../component/Profile';
import Project from '../component/Project';
import Contact from '../component/Contact';

function Main() {
  const { scrollYProgress } = useScroll()
  return (
      <main>
      <motion.div
        id="scroll-indicator"
        style={{
        scaleX: scrollYProgress,
        position: "fixed",
        top: 100,
        left: 0,
        right: 0,
        zIndex:1000,
        height: 10,
        originX: 0,
        backgroundColor: "#A2DED0",
        }}
      />
      <Intro
        text="PortFolio"
        subtext={`본 페이지는 비영리적 개인 포트폴리오 페이지입니다.\n
        일부 내용 및 이미지 등은 출처가 따로 있을 수 있습니다.\n
        해상도 1920px 1080px 환경에 최적화 되어있습니다.`}
        speed={200}
      />
      <Profile />
      <Project />
      <Contact />
      </main>
  );
}

export default Main;
